// Mock data utilities for frontend development

/**
 * Returns an array of mock files, each optionally associated with a unit and/or subunit.
 * @param {string} query - Optional search query to filter files by name.
 * @returns {Array} Array of file objects with optional unit and subunit info.
 */
export const mockFilesWithUnits = (query = "") => {
  const files = [
    {
      id: "file-1",
      name: "Lecture 1.pdf",
      size_mb: 2.5,
      unit: { id: "unit-1", title: "Unit 1" },
      subunit: { id: "subunit-1", title: "Subunit 1.1" },
      url: "/files/lecture-1.pdf"
    },
    {
      id: "file-2",
      name: "Slides 2.pptx",
      size_mb: 4.1,
      unit: { id: "unit-2", title: "Unit 2" },
      subunit: null,
      url: "/files/slides-2.pptx"
    },
    {
      id: "file-3",
      name: "General Resource.pdf",
      size_mb: 1.2,
      unit: null,
      subunit: null,
      url: "/files/general-resource.pdf"
    },
    {
      id: "file-4",
      name: "Unit 3 Notes.txt",
      size_mb: 0.8,
      unit: { id: "unit-3", title: "Unit 3" },
      subunit: { id: "subunit-3", title: "Subunit 3.1" },
      url: "/files/unit-3-notes.txt"
    },
    {
      id: "file-5",
      name: "Standalone File.docx",
      size_mb: 2.0,
      unit: null,
      subunit: null,
      url: "/files/standalone-file.docx"
    }
  ];

  if (query !== "") {
    return files.filter(f => f.name.toLowerCase().includes(query.toLowerCase()));
  }
  return files;
};


export const mockSmartNotes = () => {
  const smartNotes = [
    {
      id: `smart-note-${crypto.randomUUID()}`,
      title: "Smart Note 1",
      description: "Smart Note 1 Description",
    },
    {
      id: `smart-note-${crypto.randomUUID()}`,
      title: "Smart Note 2",
      description: "Smart Note 2 Description",
    },
    {
      id: `smart-note-${crypto.randomUUID()}`,
      title: "Smart Note 3",
      description: "Smart Note 3 Description",
    },
    {
      id: `smart-note-${crypto.randomUUID()}`,
      title: "Smart Note 4",
      description: "Smart Note 4 Description",
    }
  ];
  const count = Math.floor(Math.random() * 3) + 2; // 2 to 4
  return smartNotes.slice(0, count);
}

/**
 * Returns mock units data for MasteryMap when API response is empty
 * @returns {Array} Array of unit objects with mastery tracking
 */
export const mockUnits = () => {
  return [
    {
      id: 1,
      title: "Introduction to Course",
      description: "Getting started with the fundamentals",
      position: 0,
      completed: false,
      mastery_level: 0.2
    },
    {
      id: 2,
      title: "Core Concepts",
      description: "Understanding the main principles",
      position: 1,
      completed: false,
      mastery_level: 0.0
    },
    {
      id: 3,
      title: "Advanced Topics",
      description: "Diving deeper into complex subjects",
      position: 2,
      completed: false,
      mastery_level: 0.0
    },
    {
      id: 4,
      title: "Practical Applications",
      description: "Applying knowledge in real scenarios",
      position: 3,
      completed: false,
      mastery_level: 0.0
    }
  ];
}

/**
 * Returns mock sub-units data for a given unit
 * @param {string|number} unitId - The unit ID to generate sub-units for
 * @returns {Array} Array of sub-unit objects
 */
export const mockSubUnits = (unitId) => {
  const baseSubUnits = [
    {
      id: `${unitId}-1`,
      title: "Lesson 1",
      description: "Introduction to the topic",
      position: 0,
      familiarity: Math.floor(Math.random() * 100),
      unit_id: unitId
    },
    {
      id: `${unitId}-2`,
      title: "Lesson 2",
      description: "Building on the basics",
      position: 1,
      familiarity: Math.floor(Math.random() * 100),
      unit_id: unitId
    },
    {
      id: `${unitId}-3`,
      title: "Practice Session",
      description: "Hands-on exercises",
      position: 2,
      familiarity: Math.floor(Math.random() * 100),
      unit_id: unitId
    }
  ];

  // Return 2-4 sub-units randomly
  const count = Math.floor(Math.random() * 3) + 2;
  return baseSubUnits.slice(0, count);
}
